import React, { useEffect, useState } from "react";
import { Pagination } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { ClickEvent } from "../../shared/types/event.types";
import { fetchAdminOutages } from "../../state-management/slices/outages/outages.thunk";
import { DefaultPaginationProps, IPaginationProps } from "./Pagination.types";
import PaginationStyles from "./Pagination.styles";
import { AppDispatch } from "../../state-management/store";

const renderPageItems = (
  pages: Array<number>,
  pageSize: number | undefined,
  currentPage: number,
  dispatch: AppDispatch
) => {
  if (pages.length <= 10) {
    return pages.map((navPageNumber: number) => (
      <Pagination.Item
        onClick={() => {
          dispatch(fetchAdminOutages(pageSize, navPageNumber));
        }}
        active={currentPage === navPageNumber}
        key={navPageNumber}
      >
        {navPageNumber}
      </Pagination.Item>
    ));
  }

  if (pages.length > 10 && currentPage <= 10) {
    const pageNumbers = Array.from({ length: 10 }, (_, index) => index + 1);
    return pageNumbers.map((navPageNumber: number) => (
      <Pagination.Item
        onClick={() => {
          dispatch(fetchAdminOutages(pageSize, navPageNumber));
        }}
        active={currentPage === navPageNumber}
        key={navPageNumber}
      >
        {navPageNumber}
      </Pagination.Item>
    ));
  }

  if (pages.length > 10 && currentPage >= 10) {
    return (
      <>
        <Pagination.Item
          onClick={() => {
            dispatch(fetchAdminOutages(pageSize, currentPage - 2));
          }}
          active={false}
          key={currentPage - 2}
        >
          {currentPage - 2}
        </Pagination.Item>
        <Pagination.Item
          onClick={() => {
            dispatch(fetchAdminOutages(pageSize, currentPage - 1));
          }}
          active={false}
          key={currentPage - 1}
        >
          {currentPage - 1}
        </Pagination.Item>
        <Pagination.Item
          onClick={() => {
            dispatch(fetchAdminOutages(pageSize, currentPage));
          }}
          active={true}
          key={currentPage}
        >
          {currentPage}
        </Pagination.Item>
        <Pagination.Item
          onClick={() => {
            dispatch(fetchAdminOutages(pageSize, currentPage + 1));
          }}
          active={false}
          key={currentPage + 1}
        >
          {currentPage + 1}
        </Pagination.Item>
        <Pagination.Item
          onClick={() => {
            dispatch(fetchAdminOutages(pageSize, currentPage + 2));
          }}
          active={false}
          key={currentPage + 2}
        >
          {currentPage + 2}
        </Pagination.Item>
      </>
    );
  }
};

const PAGINATION: React.FC<IPaginationProps> = (props: IPaginationProps) => {
  const dispatch = useDispatch();
  const { data, pageSize, currentPage, totalCount } = props;

  const [pages, setPages] = useState<Array<number>>([]);

  useEffect(() => {
    if (totalCount && pageSize) {
      // Builds an array of numbers from the number of pages (number of pages is totalCount/pageSize).
      const pageNumbers = Array.from(
        { length: Math.ceil(totalCount / pageSize) },
        (_, index) => index + 1
      );

      setPages(pageNumbers);
    }
  }, [data, totalCount, pageSize]);

  return (
    <PaginationStyles.PaginationContainer className="pagination-container">
      <Pagination size="sm">
        <Pagination.First
          disabled={currentPage === 1}
          onClick={(event: ClickEvent) => {
            dispatch(fetchAdminOutages(pageSize, 1));
          }}
        />
        <Pagination.Prev
          disabled={currentPage === 1}
          onClick={(event: ClickEvent) => {
            if (currentPage > 1)
              dispatch(fetchAdminOutages(pageSize, currentPage - 1));
          }}
        />
        {pages.length &&
          renderPageItems(pages, pageSize, currentPage, dispatch)}
        <Pagination.Next
          disabled={currentPage === pages.length}
          onClick={(event: ClickEvent) => {
            if (currentPage + 1 <= pages.length)
              dispatch(fetchAdminOutages(pageSize, currentPage + 1));
          }}
        />
        <Pagination.Last
          disabled={currentPage === pages.length}
          onClick={(event: ClickEvent) =>
            dispatch(fetchAdminOutages(pageSize, pages.length))
          }
        />
      </Pagination>
    </PaginationStyles.PaginationContainer>
  );
};

PAGINATION.defaultProps = DefaultPaginationProps;
export default PAGINATION;
